export default __webpack_public_path__ + "static/media/250.4c4098c3.jpg";